/**
 * Écran « Accès non configuré » (SEC-6, 05/10/2026).
 *
 * Rendu par SectionGuard pour tout compte dont aucun rôle n'est reconnu par
 * l'Économat (mapRole → « non_configure ») : secrétaire, lecteur, parent…
 * Avant, ces comptes recevaient le rail complet de l'économe. Aucun appel
 * réseau ici : le compte n'a aucune section, il ne peut que se déconnecter.
 */
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { LogOut, ShieldQuestion } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function AccesNonConfigure() {
  const { user, setUser } = useAuth();
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50 px-4">
      <Card className="w-full max-w-md" data-testid="acces-non-configure">
        <CardContent className="pt-8 pb-6">
          <div className="flex flex-col items-center text-center">
            <div className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center mb-4">
              <ShieldQuestion className="h-8 w-8 text-amber-500" aria-hidden="true" />
            </div>
            <h1 className="text-xl font-semibold text-gray-800 mb-3">Accès non configuré</h1>
            <p className="text-sm text-gray-600 mb-2 max-w-sm">
              Accès non configuré pour votre profil, contactez l'Économat.
            </p>
            {user?.username && (
              <p className="text-xs text-gray-400 mb-6" data-testid="text-compte">
                Compte : {user.username}
              </p>
            )}
            <Button
              variant="outline"
              className="w-full"
              data-testid="button-logout-non-configure"
              onClick={() => {
                setUser(null);
                window.location.href = "/";
              }}
            >
              <LogOut className="w-4 h-4 mr-2" aria-hidden="true" />
              Se déconnecter
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
